<template>
  <div class="container page recharge-list-page">
    <van-nav-bar :title="$t('recharge.records')" class="nav-bar">
      <template #left><van-icon name="arrow-left" color="#f3c7a2" @click="back" /></template>
    </van-nav-bar>
    <van-pull-refresh v-model="refreshing" @refresh="loadList">
      <van-loading v-if="loading" class="loading" vertical>{{ $t('recharge.loading') }}</van-loading>
      <van-empty v-else-if="list.length === 0" :description="$t('withdraw.empty_data')" />
      <div v-else class="record-card" v-for="item in list" :key="item.id">
        <div class="record-head">
          <b>#{{ item.id }}</b>
          <span :class="'status status-' + item.status">{{ statusText(item.status) }}</span>
        </div>
        <div class="record-row"><span>{{ $t('recharge.amount') }}</span><strong>{{ item.money }}</strong></div>
        <div class="record-row"><span>{{ $t('recharge.submit_time') }}</span><span>{{ item.create_time }}</span></div>
        <div v-if="item.review_time" class="record-row"><span>{{ $t('recharge.review_time') }}</span><span>{{ item.review_time }}</span></div>
        <div v-if="item.review_remark" class="remark">{{ item.review_remark }}</div>
        <a v-if="item.proof" :href="item.proof" target="_blank" class="proof-link">{{ $t('recharge.view_proof') }}</a>
      </div>
    </van-pull-refresh>
  </div>
</template>

<script>
export default {
  data() { return { list: [], loading: true, refreshing: false }; },
  methods: {
    back() { window.history.back(); },
    statusText(status) {
      const map = { 0: 'pending', 1: 'rejected', 2: 'approved' };
      return this.$t('recharge.' + (map[Number(status)] || 'pending'));
    },
    loadList() {
      this.$http({ method: 'get', url: 'user_get_recharge_list' }).then(res => {
        if (res && res.code === 200) this.list = res.data || [];
        else if (res && res.code === 401) this.$toast(res.msg);
      }).finally(() => { this.loading = false; this.refreshing = false; });
    }
  },
  created() {
    if (!localStorage.getItem('token')) return this.$router.replace('/Login');
    this.loadList();
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";
.recharge-list-page { background:#1f1c1f; color:#f3c7a2; overflow:auto; }
.loading { padding-top:80px; color:#f3c7a2; }
.record-card { margin:22px; padding:24px; border:1px solid #766350; border-radius:14px; background:linear-gradient(120deg,#212121,#313131); font-size:24px; }
.record-head,.record-row { display:flex; justify-content:space-between; gap:20px; padding:12px 0; }
.record-head { border-bottom:1px solid #4c443c; font-size:27px; }
.status-0 { color:#f6bf66; }.status-1 { color:#ff6b6b; }.status-2 { color:#07c160; }
.remark { margin-top:12px; padding:14px; background:#1d1d1d; border-radius:8px; line-height:1.5; }
.proof-link { display:inline-block; margin-top:16px; color:#efbd8e; text-decoration:underline; }
</style>
